import { useState, useEffect } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useLocalStorage('isAuthenticated', false);
  const [sla, setSla] = useLocalStorage('sla', 'free');
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    // 認証状態の初期化処理があれば
  }, []);

  const login = async (username, password) => {
    try {
      // ここにログイン処理
      if (username === 'basic' && password === 'basic') {
        setIsAuthenticated(true);
        setSla('basic');
        setAuthError(null);
        return true;
      } else if (username === 'exective' && password === 'exective') {
        setIsAuthenticated(true);
        setSla('exective');
        setAuthError(null);
        return true;
      } else {
        setAuthError('Invalid credentials');
        return false;
      }
    } catch (error) {
      setAuthError(error.message);
      return false;
    }
  };

  const logout = (setPage) => {
    // 認証状態のリセット
    setIsAuthenticated(false);
    setSla('free');

    // クッキーの削除
    document.cookie = 'userinfo=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

    // ローカルストレージのクリア
    localStorage.clear();

    // ページをログイン画面に戻す
    if (setPage) {
      setPage('login');
    }
  };

  return {
    isAuthenticated,
    sla,
    authError,
    login,
    logout
  };
}; 
